var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrava2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z",
    fill: "#fc4c02"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.9 8.8l2.5 4.5 2.4-4.5h-1.5l-.9 1.7-1-1.7z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2 2.5l3.1 6.3H4zm0 3.8l1.2 2.5H5.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrava2);
export default __webpack_public_path__ + "static/media/strava-2.4b9e035a308139b25f48f3f4c0fe1056.svg";
export { ForwardRef as ReactComponent };